import { render } from "./ThePhuongXa.vue?vue&type=template&id=654bf838"
import script from "./ThePhuongXa.vue?vue&type=script&lang=js"
export * from "./ThePhuongXa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__